import { BrickInventoryEntry } from "../../../BrickInventory/BrickInventory";
import { SetEntry } from "../../../SetInventory/SetInventory";
import { ActionEntry } from "../../ActionEntries";

export const meetsCostRequirementsSets = (
  action: ActionEntry,
  newBricks: Map<string, BrickInventoryEntry>,
  newSets: Map<string, SetEntry>,
  buyAmount: number = 1,
) => {
  // Validate if costs for action can be met (both bricks and sets)
  for (let i = 0; i < action.cost.length; i++) {
    const costEntry = action.cost[i];
    const trueCost =
      (costEntry.baseChangeValue + action.costIncrement * action.costScale) *
      buyAmount;

    // Default to "brick" if type not specified (backward compatibility)
    const costType = costEntry.type || "brick";

    if (costType === "brick") {
      // Check brick costs
      const currBrick = newBricks.get(costEntry.brickId);

      if (
        !currBrick ||
        Number.isNaN(currBrick.amount) ||
        currBrick.amount < trueCost
      ) {
        return false;
      }
    } else if (costType === "set") {
      // Check set costs
      const currSet = newSets.get(costEntry.brickId); // brickId field contains set ID

      if (!currSet || currSet.count < trueCost) {
        return false;
      }
    }
  }

  return true;
};
